var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndividualIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.545 10.4272C13.4105 10.3375 13.2535 10.3599 13.1414 10.4496C12.0202 11.2793 10.6523 11.7502 9.14987 11.7502C7.64745 11.7502 6.27957 11.2569 5.15836 10.4496C5.04624 10.3599 4.86685 10.3599 4.75473 10.4272C2.10867 12.1315 0.785645 15.4727 0.785645 19.3072C0.785645 21.9533 17.5141 21.9533 17.5141 19.3072C17.5141 15.4727 16.1911 12.1315 13.545 10.4272Z",
    fill: "#294DD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14952 10.0012C11.9113 10.0012 14.1501 7.76235 14.1501 5.0006C14.1501 2.23884 11.9113 0 9.14952 0C6.38777 0 4.14893 2.23884 4.14893 5.0006C4.14893 7.76235 6.38777 10.0012 9.14952 10.0012Z",
    fill: "#294DD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualIcon);
export default __webpack_public_path__ + "static/media/individualIcon.efe4d2d0289ddb0259e5c49d15579f90.svg";
export { ForwardRef as ReactComponent };